export default {
      id: "NZD-usage",
      viewBox: "0 0 31.2 22",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#NZD",
      toString: function () {
        return this.url;
      }
    }